var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "costunit-list-table" },
    [
      _c("b-table", {
        attrs: {
          fields: _vm.fields,
          items: _vm.tableItems,
          responsive: "",
          striped: "",
        },
        scopedSlots: _vm._u([
          {
            key: "head()",
            fn: function (data) {
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(data.label.toUpperCase()) +
                    "\n        "
                ),
              ]
            },
          },
          {
            key: "cell(costUnitText)",
            fn: function (data) {
              return [
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.emptyValuePlaceholder(data.value))),
                ]),
                _vm._v(" "),
                data.item.sourceText
                  ? _c("span", [
                      _c("br"),
                      _vm._v(
                        "\n                (" +
                          _vm._s(data.item.sourceText) +
                          ")\n            "
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(dateReceipt)",
            fn: function (data) {
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.formatDate(data.value)) +
                    "\n        "
                ),
              ]
            },
          },
          {
            key: "cell(amount)",
            fn: function (data) {
              return [
                _c("csp-costunit-amount-table", {
                  attrs: {
                    "amount-property-prefix": "amount",
                    "cost-unit": data.item,
                    "show-insurance-figure-label": "",
                  },
                }),
              ]
            },
          },
          {
            key: "cell(paymentSums)",
            fn: function (data) {
              return [
                _c("csp-costunit-amount-table", {
                  attrs: {
                    "amount-property-prefix": "paymentsSum",
                    "cost-unit": data.item,
                    "is-payment": "",
                    "sum-positive-class": "text-success",
                  },
                }),
              ]
            },
          },
          {
            key: "cell(datePaid)",
            fn: function (data) {
              return [
                data.item.latestPayment.data
                  ? [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.formatDate(
                              data.item.latestPayment.data.attributes.datePaid
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(amountOpen)",
            fn: function (data) {
              return [
                _c("csp-costunit-amount-table", {
                  attrs: {
                    "amount-property-prefix": "amountOpen",
                    "cost-unit": data.item,
                    "highlight-insurance-payment": "",
                    "sum-positive-class": "text-danger",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "amountPrefix",
                        fn: function () {
                          return [
                            data.item.hasAmountAdjustment
                              ? _c("span", [_vm._v("*")])
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ]
            },
          },
          {
            key: "cell(comment)",
            fn: function (data) {
              return [
                _c("span", { staticStyle: { "white-space": "pre-wrap" } }, [
                  _vm._v(_vm._s(data.value)),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }